export default __webpack_public_path__ + "static/media/refresh.02c236d9.svg";